module.exports = __webpack_public_path__ + "d43447b224b60007b2e9a238d392bb05.png";